import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '@n8n/chat/style.css';
import '../assets/styles/components/ChatWidget.css';
import { createChat } from '@n8n/chat';

export const ChatWidget = () => {
  const { i18n } = useTranslation();
  const chatInstanceRef = useRef(null);

  useEffect(() => {
    const currentLanguage = (i18n.language || 'en').split('-')[0]; // Get base language code (en from en-US)
    
    console.log('Current language:', currentLanguage);
    console.log('i18n.language:', i18n.language);

    const initialMessagesByLanguage = {
      en: ['Hi there! 👋', 'My name is Nathan. How can I assist you today?'],
      es: ['¡Hola! 👋', 'Mi nombre es Nathan. ¿Cómo puedo ayudarte?'],
    };
    const i18nConfig = {
      en: {
        title: 'Hi there! 👋',
        subtitle: 'Start a chat. We\'re here to help you 24/7.',
        footer: '',
        getStarted: 'New Conversation',
        inputPlaceholder: 'Type your question..',
      },
      es: {
        title: '¡Hola! 👋',
        subtitle: 'Comienza un chat. Estamos aquí para ayudarte 24/7.',
        footer: '',
        getStarted: 'Nueva conversación',
        inputPlaceholder: 'Escribe tu pregunta..',
      },
    };

    const initialMessages = initialMessagesByLanguage[currentLanguage] || initialMessagesByLanguage.en;

    if (chatInstanceRef.current) {
      chatInstanceRef.current.unmount();
    }

    setTimeout(() => {
      chatInstanceRef.current = createChat({
        webhookUrl: '/n8n/webhook/9fd010b2-e275-47a3-a132-c0e143826b9b/chat',
        webhookConfig: {
          method: 'POST',
          headers: {},
        },
        target: '#n8n-chat',
        mode: 'window',
        chatInputKey: 'chatInput',
        chatSessionKey: 'sessionId',
        loadPreviousSession: false,
        metadata: {},
        initialMessages,
        defaultLanguage: currentLanguage,
        i18n: i18nConfig,
      });
    }, 0);

    return () => {
      if (chatInstanceRef.current) {
        chatInstanceRef.current.unmount();
      }
    };
  }, [i18n.language]);

  return <div id="n8n-chat" />;
};

export default ChatWidget;
